export const UserType = Object.freeze({
  INVESTOR: 'INVESTOR',
  OWNER: 'OWNER',
  REALESTATE: 'REALESTATE',
});